import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsHacktheboxComponent } from './simple-icons-hackthebox.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsHacktheboxComponent ],
    exports:      [ SimpleIconsHacktheboxComponent ],
    bootstrap:    []
})
export class SimpleIconsHacktheboxModule {}
